module.exports = __webpack_public_path__ + "static/img/kols13.9b46923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols13.png
// module id = QqLl
// module chunks = 0